import OrgChartStructure from '@/api/hr/org-chart-structure'
import { baseState, baseMutations } from '@/store/mixins'
import Company from '@/api/administration/company'
import OrgChartLevel from '@/api/hr/org-chart-level'

export const state = {
  ...baseState,
  companies: [],
  orgChartLevels: [],
  parentStructures: []
}

export const getters = {
  orgChartLevelsByCompany: state => companyId => state.orgChartLevels.filter(level => level.company_id == companyId),

  orgChartParentStructuresByCompany: state => companyId =>
    state.parentStructures.filter(structure => structure.company_id == companyId)
}

export const mutations = {
  ...baseMutations,
  RECEIVE_COMPANIES(state, companies) {
    state.companies = companies
  },

  RECEIVE_ORG_CHART_LEVEL(state, orgChartLevels) {
    state.orgChartLevels = orgChartLevels
  },

  RECEIVE_ORG_CHART_PARENT_STRUCTURES(state, parentStructures) {
    state.parentStructures = parentStructures
  }
}

export const actions = {
  fetch(context, attributes = {}) {
    const params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search,
        ...context.state.queryBuilder
      },
      attributes
    )

    context.commit('SET_QUERY_BUILDER', attributes)

    return OrgChartStructure.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  create(context, data) {
    return OrgChartStructure.store(data)
  },

  update(context, { id, ...data }) {
    return OrgChartStructure.update(id, data)
  },

  destroy(context, id) {
    return OrgChartStructure.destroy(id)
  },

  async fetchCompanies({ commit, rootGetters }) {
    const response = await Company.get({
      params: { page: -1 },
      headers: {
        'X-PERMISSION-ALLOW-CODE': rootGetters.permissionAllowCode
      }
    })
    commit('RECEIVE_COMPANIES', response.data)
  },

  async fetchOrgChartLevel({ commit }) {
    const response = await OrgChartLevel.get({ params: { page: -1 } })
    commit('RECEIVE_ORG_CHART_LEVEL', response.data)
  },

  async fetchParentStructures({ commit }) {
    const response = await OrgChartStructure.get({ params: { page: -1 } })
    commit('RECEIVE_ORG_CHART_PARENT_STRUCTURES', response.data)
  }
}
